export enum DeliveryMethod {
  Email = 'alternate_email',
  WordPress = 'wordpress',
  HubSpot = 'hubspot',
  PlusOrComplete = 'plus_optimize_or_verblio_complete'
}
